import { Component, Input, OnInit } from '@angular/core';
import { IriDataService } from 'src/app/features/stock-screener/services/iri-data-service.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { ChangeDetectorRef } from '@angular/core';
import { ApiService } from 'src/app/shared/services/api.service';
import { ConditionalRenderingService } from 'src/app/shared/services/conditional-rendering.service';
import { TypesenseService } from 'src/app/shared/services/typesense.service';

@Component({
    selector: 'app-iri-report',
    templateUrl: './iri-report.component.html',
    styleUrls: ['./iri-report.component.scss'],
    standalone: false
})
export class IriReportComponent implements OnInit {
   isIriPage: boolean = true;
   isUserLoggedIn: boolean = false;
   // Declare class-level properties
   musaffaData: any = null;
   communityData: any = null;
   @Input() symbol: string = 'AAPL'; // Default to AAPL if not provided
   @Input() userRoleNew: string = 'free'; // Default to AAPL if not provided
   @Input() symbolMainTicker: string = 'AAPL'; // Default to AAPL if not provided
   @Input() isSample: boolean = false;
   @Input() country: string = '';
   @Input() isSubscribed: boolean = false;
   isLoading: boolean = true;
   relatedStocks: any[] = [];

   constructor(
      private iriDataService: IriDataService,
      private auth: AuthService,
      private cdr: ChangeDetectorRef,
      private apiService: ApiService,
      private conditionalRenderingService: ConditionalRenderingService,
      private typesenseService: TypesenseService
   ) {}
   get isPremiumUser(): boolean {
      return this.isSubscribed
   }

   async ngOnInit(): Promise<void> {
      try {
         this.isLoading = true;

         // Fetch both data sources concurrently
         const [musaffaResult, communityResult] = await Promise.all([
            this.iriDataService.getMusaffaIriData(this.symbol),
            this.iriDataService.getCommunityIriData(this.symbol),
         ]);

         this.musaffaData = musaffaResult;
         this.communityData = communityResult;

         await this.getRelatedStocks();
      } catch (error) {
         console.error('Error loading IRI data:', error);
      } finally {
         this.isLoading = false;
      }

      this.cdr.detectChanges();
      this.isPremiumUser;
      // console.log("this.isPremiumUser:",this.isPremiumUser)
      // console.log('IriReportComponent initialized for symbol:', this.symbol);
      this.isUserLoggedIn = !!this.auth.getUserId();
   }

   // async getRelatedStocks(): Promise<void> {
   //    const relatedStocks = await this.apiService.getRelatedStocks(this.symbol);
   //    this.relatedStocks = relatedStocks.hits.map((hit: any) => hit.document);
   //    const tickers = this.relatedStocks.map((stock: any) => stock.ticker);
   //    const iriData = await this.iriDataService.fetchIriData(tickers);
   //    // Combine IRI data with related stocks
   //    const musaffaIriData = iriData.results[0]?.hits || [];
   //    const communityIriData = iriData.results[1]?.hits || [];

   //    this.relatedStocks = this.relatedStocks.map((stock: any) => {
   //       const musaffaIri = musaffaIriData.find(
   //          (hit: any) => hit.document.symbol === stock.symbol
   //       )?.document;
   //       const communityIri = communityIriData.find(
   //          (hit: any) => hit.document.symbol === stock.symbol
   //       )?.document;

   //       // console.log('musaffaIri:', relatedStocks);

   //       return {
   //          ...stock,
   //          id: stock.ticker,
   //          sharia_compliance: stock?.shariahCompliantStatus,
   //          musaffa_iri_score: musaffaIri?.iri_score,
   //          community_iri_score: communityIri?.iri_score,
   //       };
   //    });
   // }

   async getRelatedStocks(): Promise<void> {
      const relatedStocks =
         await this.iriDataService.getCompanyProfileAndDataByCountryIsri(
            this.country,
            this.symbol
         );
      this.relatedStocks = Object.values(relatedStocks);
      const noMusaffaIriStocks = this.relatedStocks.filter(
         (stock: any) => !stock.musaffa_iri_score
      );
      const tickers = noMusaffaIriStocks.map((stock: any) => stock.ticker);
      const iriData = await this.iriDataService.fetchMusaffaIriDataBySymbols(
         tickers
      );
      const musaffaIriData = iriData || [];

      this.relatedStocks = this.relatedStocks.map((stock: any) => {
         const musaffaIri = musaffaIriData.find(
            (hit: any) => hit.document.id === stock.id
         )?.document;
         if (musaffaIri) {
            return {
               ...stock,
               musaffa_iri_score: musaffaIri?.iri_score,
            };
         }
         return stock;
      });
      // const relatedStocks = await this.apiService.getRelatedStocks(this.symbol);
      // this.relatedStocks = relatedStocks.hits.map((hit: any) => hit.document);
      // const tickers = this.relatedStocks.map((stock: any) => stock.ticker);
      // const iriData = await this.iriDataService.fetchIriData(tickers);
      // // Combine IRI data with related stocks
      // const musaffaIriData = iriData.results[0]?.hits || [];
      // const communityIriData = iriData.results[1]?.hits || [];
   }

   onViewSampleClicked(type: string): void {
      this.conditionalRenderingService.setComponentType(type);
      // your custom logic here
   }

   async refreshData(): Promise<void> {
      // console.log('Refreshing IRI data for symbol:', this.symbol);
      try {
         this.isLoading = true;

         // Force a refresh of the data
         await this.iriDataService.refreshIriData(this.symbol);

         // Get the refreshed data
         this.musaffaData = await this.iriDataService.getMusaffaIriData(
            this.symbol
         );
         this.communityData = await this.iriDataService.getCommunityIriData(
            this.symbol
         );

         // console.log('Refreshed Musaffa IRI Data:', this.musaffaData);
         // console.log('Refreshed Community IRI Data:', this.communityData);
      } catch (error) {
         console.error('Error refreshing IRI data:', error);
      } finally {
         this.isLoading = false;
      }
   }

   // In the parent component (IriReportComponent)
   async onRatingCompleted(success: boolean) {
      if (success) {
         //  console.log('[DEBUG-PARENT] Refreshing community data...');

         // Force fresh API call by bypassing cache
         this.communityData = await this.iriDataService.fetchCommunityIriData(
            this.symbol
         );

         //  console.log('[DEBUG-PARENT] New communityData:', this.communityData);

         // Ensure user-specific data is cleared
         this.communityData = {
            ...this.communityData,
            community_impact_and_reputation: null,
            human_rights_and_labor_practices: null,
            product_and_sector_involvement: null,
            environmental_responsibility: null,
            ethical_governance: null,
         };

         this.cdr.detectChanges();
      }
   }

   columns = [
      {
         header: 'Compliance',
         key: 'sharia_compliance',
         sortable: false,
      },
      {
         header: 'Halal Rating',
         key: 'ranking_v2',
         sortable: false,
      },
      {
         header: 'Musaffa ISRI Score',
         key: 'musaffa_iri_score',
         type: 'musaffa_iri_score',
         sortable: false,
      },
      {
         header: 'Community ISRI Score',
         key: 'community_iri_score',
         type: 'musaffa_iri_score',
         sortable: false,
      },
      {
         header: 'Price',
         key: 'currentPrice',
         type: 'amount',
         sortable: false,
      },
   ];

   stocks = [
      // {
      //    ticker: 'AAPL',
      //    name: 'Apple Inc.',
      //    sharia_compliance: 'NON_COMPLIANT',
      //    ranking_v2: 0,
      //    musaffa_iri_score: 1,
      //    community_iri_score: 1,
      //    currentPrice: 145.67,
      // },
      // {
      //    ticker: 'GOOG',
      //    name: 'Alphabet Inc.',
      //    sharia_compliance: 'COMPLIANT',
      //    ranking_v2: 4,
      //    musaffa_iri_score: 2,
      //    community_iri_score: 2,
      //    currentPrice: 145.67,
      // },
      // {
      //    ticker: 'AMZN',
      //    name: 'Amazon.com Inc.',
      //    sharia_compliance: 'NON_COMPLIANT',
      //    ranking_v2: 8,
      //    musaffa_iri_score: 3,
      //    community_iri_score: 3,
      //    currentPrice: 145.67,
      // },
      // {
      //    ticker: 'NFLX',
      //    name: 'Netflix Inc.',
      //    sharia_compliance: 'NON_COMPLIANT',
      //    ranking_v2: 6,
      //    musaffa_iri_score: 1,
      //    community_iri_score: 1,
      //    currentPrice: 145.67,
      // },
      // {
      //    ticker: 'TSLA',
      //    name: 'Tesla Inc.',
      //    sharia_compliance: 'COMPLIANT',
      //    ranking_v2: 5,
      //    musaffa_iri_score: 2,
      //    community_iri_score: 2,
      //    currentPrice: 145.67,
      // },
      // {
      //    ticker: 'NVDA',
      //    name: 'NVIDIA Corporation',
      //    sharia_compliance: 'COMPLIANT',
      //    ranking_v2: 9,
      //    musaffa_iri_score: 1,
      //    community_iri_score: 1,
      //    currentPrice: 145.67,
      // },
   ];

   // Other required properties for the dynamic table
   page = 1;
   totalStocksCount = this.stocks.length;
   // isLoading = false;
   sortColumn = 'currentPrice';
   sortOrder = 'asc';
   dataType = 'stocks';
   // showISRIOverview = false;
}
